export function findDrugHref(xmlDoc, drugName) {
  const rows = xmlDoc.querySelectorAll("relrow");

  for (const row of rows) {
    const cells = row.querySelectorAll("relcell");

    const topichead = cells[0]?.querySelector("topichead");
    const navtitle = topichead?.getAttribute("navtitle");

    if (navtitle && navtitle.toLowerCase() === drugName.toLowerCase()) {
      const topicref = cells[1]?.querySelector("topicref");
      const href = topicref?.getAttribute("href");
      return href || null;
    }
  }

  return null;
}
